var render, staticRenderFns
import script from "./vCheckbox.vue?vue&type=script&lang=js"
export * from "./vCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1671fc34')) {
      api.createRecord('1671fc34', component.options)
    } else {
      api.reload('1671fc34', component.options)
    }
    
  }
}
component.options.__file = "src/vab/components/VabValidateTable/components/vCheckbox.vue"
export default component.exports